import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../service/config.service';
import { DomSanitizer } from '@angular/platform-browser';
import {  Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-pac',
  templateUrl: './pac.component.html',
  styleUrls: ['./pac.component.scss']
})
export class PacComponent implements OnInit {

  constructor(configService: ConfigService,private sanitizer: DomSanitizer,private router: Router,private route: ActivatedRoute) { 
    
    

    this.uniqueToken = encodeURIComponent(this.route.snapshot.paramMap.get('uniquetoken'));
    //alert(this.uniqueToken);
    this.pacURI = configService.GetPacURI();
  }
  uniqueToken: string;
  pacURI: string;
  pacUrl: any;
  ngOnInit() {
   // alert("pac");
    this.pacUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pacURI + 'home/' + this.uniqueToken);

  }

}
